import script from "./EditUserModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EditUserModal.vue?vue&type=script&setup=true&lang=js"

import "./EditUserModal.vue?vue&type=style&index=0&id=428c669e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-428c669e"]])

export default __exports__